export enum ToolStatus {
  ASSEMBLING = 'ASSEMBLING',
  FREE = 'FREE',
  IN_MAINTENANCE = 'IN_MAINTENANCE',
  IN_USE = 'IN_USE',
  NOT_AVAILABLE = 'NOT_AVAILABLE'
}
